import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["button", "content", "textarea", "form", "switch"];

  connect() {
    const currentPath = window.location.pathname;
    const activeTab = this.element.dataset.activeTab;

    if (currentPath != "/app/profile") {
      this.textareaTarget.addEventListener("blur", () => {
        this.formTarget.requestSubmit();
      });
    }

    this.restoreActiveTab(activeTab);
  }

  restoreActiveTab(serverActiveTab) {
    const storageKey = 'profile-tab-selection';
    const savedTab = localStorage.getItem(storageKey);

    let targetContentId = 'content0';

    if (savedTab && this.contentTargets.find(content => content.id === savedTab)) {
      targetContentId = savedTab;
    } else if (serverActiveTab === 'belly_circumference_in_cm') {
      targetContentId = 'content1';
    }

    this.activateTab(targetContentId);
  }

  activateTab(contentId) {
    this.buttonTargets.forEach((button) => {
      const li = button.closest("li");
      if (button.dataset.content === contentId) {
        li.classList.add("active");
      } else {
        li.classList.remove("active");
      }
    });

    this.contentTargets.forEach((content) => {
      content.classList.toggle("hidden", content.id !== contentId);
    });
  }

  setActive(event) {
    const clickedButton = event.target;
    const contentId = clickedButton.dataset.content;

    const storageKey = 'profile-tab-selection';
    localStorage.setItem(storageKey, contentId);

    this.activateTab(contentId);
  }

  submit(event) {
    this.switchTarget.requestSubmit();
  }
}
